import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { getMediaNumericTimer, getNumericTimer, getPlayerById } from '../../../../sports/genericUtils.js'
import { GAME_FACT_SOCCER_SECONDYELLOWCARD, GAME_FACT_SOCCER_SHOT, GAME_FACT_SOCCER_YELLOWCARD, reasonListSoccer } from '../data/constants.js'
import { useDirect } from '../DirectContext.js'
import './preview.css'
import ItemResolver from './items/ItemResolver.js'
import CustomDivider from './dsasComponents/CustomDivider.js'
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material'
import { GAME_FACT_BASKET_FREETHROW, GAME_FACT_BASKET_THREEPOINTS, GAME_FACT_BASKET_TWOPOINTS, GAME_FACT_DROP, GAME_FACT_ESSAI, GAME_FACT_HANDBALL_GOAL, GAME_FACT_HANDBALL_PENALTY, GAME_FACT_PENALITE, GAME_FACT_SOCCER_BUT, GAME_FACT_SOCCER_PENALTY, GAME_FACT_TRANSFORMATION } from './gamefacts/types.js'
import { MEDIA_NOTATION, MEDIA_QUESTIONBOX, MEDIA_QUIZZ, MEDIA_SURVEY } from './medias/types.js'
import StatsTableView from '../../../../../components/Live/utils/StatView.js'
import DsasButton from '../../../../components/DsasButton/DsasButton.js'
import { faEdit, faEye, faTrash } from '@fortawesome/free-solid-svg-icons'
import { faCircleLeft } from '@fortawesome/free-regular-svg-icons'

const MatchPreview = ({loadMore, handleEventEdit, handleEventDelete, handleViewObserver}) => {

    const match = useDirect()

    const [pinItems, setPinItems] = useState([])

    const [items, setItems] = useState([])
    const [visibleItems, setVisibleItems] = useState(10);

    const [isFiltered, setIsFiltered] = useState(false)

    const [statsMode, setStatsMode] = useState([])

    // Reset des cartons jaunes
    const yellowCardSoccerPlayers = []

    useEffect(() => {

        if(!match.isComplete)
            return

        const getPlayer = (id) => getPlayerById(id, match);

          let buildGameFacts = match.gameFacts
            .sort((a, b) => {
                if (a.detail.period < b.detail.period) {
                    return -1;
                } else if (a.detail.period > b.detail.period) {
                    return 1;
                } else {
                    return a.detail.timer - b.detail.timer;
                }
            })

            // Perfectionner le rendu generique et apports des modifs sur le model
            buildGameFacts = buildGameFacts.map(gf => {
                switch(gf.type){
                    case GAME_FACT_SOCCER_SHOT : 
                        return {...gf, detail : {...gf.detail, player : gf.detail.shoter}}
                    case GAME_FACT_SOCCER_YELLOWCARD : 
                        if(gf.detail.player && yellowCardSoccerPlayers.includes(gf.detail.player+gf.detail.team)){
                            var player = getPlayer(gf.detail.player)
                            var reasonInfo = gf.detail.reason ? reasonListSoccer.find(r => r.id === gf.detail.reason) : null
                            let title = "CARTON ROUGE"
                            let text = gf.detail?.text ? gf.detail.text : `2eme carton jaune pour ${player.lastname}! ${reasonInfo ? 'Raison: '+reasonInfo.value +'.' : ''} C'est donc un carton rouge pour ${player.lastname} !`
                            // 2eme jaune
                            return {...gf, type : GAME_FACT_SOCCER_SECONDYELLOWCARD, detail : {...gf.detail, title, text}}
                        }else{
                            yellowCardSoccerPlayers.push(gf.detail.player+gf.detail.team)
                            return {...gf}
                        }
                    default : 
                        return {...gf}
                }

            })

            let buildQuestionBox = match.questionBoxes ? match.questionBoxes.map(i => ({...i, type : 'questionBox'})) : []
            let buildMedias = match.quizzs ? match.quizzs.map(i => ({...i, type : 'quizz'})) : []
            let buildSurveys = match.surveys ? match.surveys.map(i => ({...i, type : 'survey'})) : []
            let buildNotations = match.notations ? match.notations.map(i => ({...i, type : 'notation'})) : []
            let buildArticles = match.articles ? match.articles.map(i => ({...i, type : 'article'})) : []

            const sortThings = (a, b) => {
                const getTimer = (obj) => (obj.detail ? obj.detail.timer : obj.timer)
                const getPeriod = (obj) => (obj.detail ? obj.detail.period : obj.period)

                const aTimer = getTimer(a)
                const bTimer = getTimer(b)

                const aPeriod = getPeriod(a)
                const bPeriod = getPeriod(b)

                const isOpta = (obj) =>
                    obj?.thirdPartyId === 'opta' ||
                    obj?.detail?.thirdPartyId === 'opta'

                const bothOpta = isOpta(a) && isOpta(b)

                const hasNumericTimer = (t) =>
                    typeof t === 'number' && !Number.isNaN(t)

                // --- CAS SPÉCIFIQUE OPTA ---
                // période : DÉCROISSANT
                // timer (si même période) : DÉCROISSANT
                if (bothOpta && hasNumericTimer(aTimer) && hasNumericTimer(bTimer)) {
                    // 1) comparer la période (décroissant → plus grande d'abord)
                    if (aPeriod !== undefined && bPeriod !== undefined && aPeriod !== bPeriod) {
                    return aPeriod > bPeriod ? -1 : 1
                    }

                    // 2) même période → comparer les timers (décroissant)
                    const aFullTimer = a.detail
                    ? getNumericTimer(a.detail.timer, a.detail.period, match.discipline)
                    : getMediaNumericTimer(a.timer, a.period, match.discipline)

                    const bFullTimer = b.detail
                    ? getNumericTimer(b.detail.timer, b.detail.period, match.discipline)
                    : getMediaNumericTimer(b.timer, b.period, match.discipline)

                    if (aFullTimer !== bFullTimer) {
                    // DÉCROISSANT sur le timer
                    return aFullTimer > bFullTimer ? -1 : 1
                    }

                    // 3) fallback sur les dates (comme avant)
                    const getDisplayDate = (obj) =>
                    new Date(obj?.detail?.displayDate ?? obj?.displayDate ?? obj?.creation)

                    const getCreationDate = (obj) => new Date(obj?.creation)

                    const bDisplayDate = getDisplayDate(b)
                    const aDisplayDate = getDisplayDate(a)

                    if (bDisplayDate < aDisplayDate) return -1
                    if (bDisplayDate > aDisplayDate) return 1

                    const bCreation = getCreationDate(b)
                    const aCreation = getCreationDate(a)

                    if (bCreation < aCreation) return -1
                    if (bCreation > aCreation) return 1

                    return 0
                }
                // --- LOGIQUE CLASSIQUE ---

                if (bTimer === 0 || aTimer === 0) {
                    const getDisplayDate = (obj) =>
                    new Date(obj?.detail?.displayDate ?? obj?.displayDate ?? obj?.creation)

                    const getCreationDate = (obj) => new Date(obj?.creation)

                    const bDisplayDate = getDisplayDate(b)
                    const aDisplayDate = getDisplayDate(a)

                    if (bDisplayDate < aDisplayDate) return -1
                    if (bDisplayDate > aDisplayDate) return 1

                    const bCreationDate = getCreationDate(b)
                    const aCreationDate = getCreationDate(a)

                    if (bCreationDate < aCreationDate) return -1
                    if (bCreationDate > aCreationDate) return 1

                    return 0
                }

                const bFullTimer = b.detail
                    ? getNumericTimer(b.detail.timer, b.detail.period, match.discipline)
                    : getMediaNumericTimer(b.timer, b.period, match.discipline)

                const aFullTimer = a.detail
                    ? getNumericTimer(a.detail.timer, a.detail.period, match.discipline)
                    : getMediaNumericTimer(a.timer, a.period, match.discipline)

                if (bFullTimer < aFullTimer) {
                    if (bPeriod > aPeriod) return 1
                    return -1
                }
                if (bFullTimer > aFullTimer) {
                    if (bPeriod < aPeriod) return -1
                    return 1
                }

                const bCreation = new Date(b.creation)
                const aCreation = new Date(a.creation)

                if (bCreation < aCreation) return -1
                if (bCreation > aCreation) return 1

                return 0
                }

            setPinItems(buildQuestionBox.filter(g => g.isPin).concat(buildMedias.filter(g => g.isPin)).concat(buildSurveys.filter(g => g.isPin)).concat(buildNotations.filter(g => g.isPin)).concat(buildArticles.filter(g => g.isPin)).sort(sortThings))

            setItems((buildGameFacts.concat(buildQuestionBox.filter(g => !g.isPin)).concat(buildMedias.filter(g => !g.isPin)).concat(buildSurveys.filter(g => !g.isPin)).concat(buildNotations.filter(g => !g.isPin)).concat(buildArticles.filter(g => !g.isPin))).sort(sortThings))
    }, [match])

    const handleShowMore = async () => {

        if(match.hasMore)
            await loadMore()

        const newVisibleItems = visibleItems + 10;
        setVisibleItems(newVisibleItems);
    };

    const disabledShowMore = useMemo(() => {
        return visibleItems >= items.length
        && !match.hasMore
    }, [match.hasMore, visibleItems, items])

    const postFilter = useCallback((items) => {
        if(isFiltered){
            return items.filter(i => [
                GAME_FACT_SOCCER_PENALTY,
                GAME_FACT_SOCCER_BUT, 

                GAME_FACT_ESSAI, 
                GAME_FACT_TRANSFORMATION, 
                GAME_FACT_PENALITE, 
                GAME_FACT_DROP,

                GAME_FACT_BASKET_FREETHROW,
                GAME_FACT_BASKET_TWOPOINTS,
                GAME_FACT_BASKET_THREEPOINTS,

                GAME_FACT_HANDBALL_GOAL,
                GAME_FACT_HANDBALL_PENALTY
            ].includes(i.type))
        }

        return items

    }, [isFiltered])

    // TODO NO LOAD
    if(!match.isComplete)
        return <CircularProgress/>

    return <Box className="direct-preview">
        <Box className='centered-wrapper'>
            <Typography variant='h2' sx={{textTransform:'uppercase'}}>Historique des posts</Typography>
        </Box>
        <Box className='centered-wrapper'>
            <DsasButton 
                label={`${isFiltered ? 'Tout afficher' : 'Afficher les buts'}`} 
                variant='secondary' 
                onClick={() => setIsFiltered(s => !s)}  
                icon={faEye} 
            />
        </Box>
        <Box className='medium-padding'></Box>

        <Box className="preview">
        {/**PINNED ITEMS */}
        {pinItems.length>0 && <Stack spacing={0}>
            {postFilter(pinItems).map((t, idx) =>
                <React.Fragment key={t._id}>
                        
                    <Box className='bordered-wrapper gamefacts-history-wrapper' sx={{padding:0}}>
                    {statsMode.includes(t._id) ? 
                            <>
                                <StatsTableView data={t}/>
                                <Box className='centered-wrapper'>
                                <DsasButton 
                                    label='Retour'
                                    variant='secondary' 
                                    customClassname='smaller'
                                    onClick={() => {
                                    setStatsMode((s) => {
                                        const newStats = [...s];
                                        const index = newStats.indexOf(t._id);
                                        if (index !== -1) {
                                        newStats.splice(index, 1);
                                        }
                                        return newStats;
                                    });
                                    }} 
                                    icon={faCircleLeft} 
                                />
                                </Box>
                            </> 
                        : 
                            <>
                            <Box sx={{pt:2}}>
                                <ItemResolver item={t} match={match} />
                            </Box>
                            <Box className='large-separator'></Box>
                                   
                                <Box sx={{alignContent: 'center',
                                    display: 'flex',
                                    justifyContent: 'space-evenly',
                                    flexWrap: 'wrap',
                                    flexDirection: 'row',
                                    alignItems: 'center'}}>
                                    {[MEDIA_QUESTIONBOX].includes(t.type) && <>
                                        <Box className='centered-column-wrapper'>
                                        <DsasButton 
                                                label='Questions'
                                                variant='secondary' 
                                                customClassname='smaller'
                                                onClick={() => handleViewObserver(t)}
                                                icon={faEye} 
                                                customCss={{margin:0, marginTop:'10px', marginBottom:'10px'}}
                                            />
                                        </Box>
                                        <Box className='large-vertical-separator'></Box></>
                                    }
                                    {[MEDIA_NOTATION, MEDIA_SURVEY, MEDIA_QUIZZ].includes(t.type) && <>
                                        <Box className='centered-column-wrapper'>
                                             <DsasButton 
                                            label='Résultat'
                                            variant='secondary' 
                                            customClassname='smaller'
                                            onClick={() => setStatsMode(s => [...s, t._id])}
                                            icon={faEye} 
                                            customCss={{margin:0, marginTop:'10px', marginBottom:'10px'}}
                                            />
                                        </Box>
                                        <Box className='large-vertical-separator'></Box></>                                       
                                    }

                                    <Box className='centered-column-wrapper'>
                                    <DsasButton 
                                            label='Editer'
                                            variant='secondary' 
                                            customClassname='smaller'
                                            onClick={() => handleEventEdit(t)}
                                            icon={faEdit} 
                                            customCss={{margin:0, marginTop:'10px', marginBottom:'10px'}}
                                        />
                                     </Box>
                                    <Box className='large-vertical-separator'></Box>

                                    <Box className='centered-column-wrapper'>
                                    <DsasButton 
                                            label='Supprimer'
                                            variant='secondary'
                                            customClassname='smaller' 
                                            onClick={() => handleEventDelete(t)}
                                            icon={faTrash} 
                                            customCss={{margin:0, marginTop:'10px', marginBottom:'10px'}}
                                        />
                                    </Box>
                                </Box>
                            </>
                    }
                    </Box>
                </React.Fragment>
            )}

            <Box className='small-padding'></Box>
            <CustomDivider/>
            <Box className='small-padding'></Box>
        </Stack>}

        {/*CLASSIC UNPINNED ITEMS*/}
        <Stack spacing={0}>
        {postFilter(items).slice(0, visibleItems).map((t, idx) => 
            <React.Fragment key={t._id}>
                {statsMode.includes(t._id) ?
                            <>
                                <StatsTableView data={t}/>
                                <Box className='centered-wrapper'>
                                <DsasButton 
                                    label='Retour'
                                    variant='secondary' 
                                    customClassname='smaller'
                                    onClick={() => {
                                    setStatsMode((s) => {
                                        const newStats = [...s];
                                        const index = newStats.indexOf(t._id);
                                        if (index !== -1) {
                                        newStats.splice(index, 1);
                                        }
                                        return newStats;
                                    });
                                    }}
                                    icon={faCircleLeft} 
                                />
                                </Box>
                            </>
                          
                        : <Box className='bordered-wrapper gamefacts-history-wrapper'>
                            <Box className='small-padding'>
                                <ItemResolver item={t} match={match} />
                            </Box>
                            <Box className='large-separator'></Box>
                                   
                            <Box sx={{alignContent: 'center',
                                display: 'flex',
                                justifyContent: 'space-evenly',
                                flexWrap: 'wrap',
                                flexDirection: 'row',
                                alignItems: 'center'}}>
                                    {[MEDIA_QUESTIONBOX].includes(t.type) && <>
                                    <Box className='centered-column-wrapper'>
                                      <DsasButton 
                                        label='Questions'
                                        variant='secondary' 
                                        customClassname='smaller'
                                        onClick={() => handleViewObserver(t)}
                                        icon={faEye} 
                                        customCss={{margin:0, marginTop:'10px', marginBottom:'10px'}}
                                        />
                                    </Box>
                                    <Box className='large-vertical-separator'></Box>
                                    </>
                                    }
                                {[MEDIA_NOTATION, MEDIA_SURVEY, MEDIA_QUIZZ].includes(t.type) && <>
                                <Box className='centered-column-wrapper'>
                                    <DsasButton 
                                        label='Résultats'
                                        variant='secondary' 
                                        customClassname='smaller'
                                        onClick={() => setStatsMode(s => [...s, t._id])}
                                        icon={faEye} 
                                        customCss={{margin:0, marginTop:'10px', marginBottom:'10px'}}
                                    />
                                </Box>
                                <Box className='large-vertical-separator'></Box>
                                    </>
                                }
                                <Box className='centered-column-wrapper'>
                                <DsasButton 
                                        label='Editer'
                                        variant='secondary' 
                                        customClassname='smaller'
                                        onClick={() => handleEventEdit(t)}
                                        icon={faEdit} 
                                        customCss={{margin:0, marginTop:'10px', marginBottom:'10px'}}
                                    />
                                </Box>
                                <Box className='large-vertical-separator'></Box>

                                <Box className='centered-column-wrapper'>
                                <DsasButton 
                                        label='Supprimer'
                                        variant='secondary' 
                                        customClassname='smaller'
                                        onClick={() => handleEventDelete(t)}
                                        icon={faTrash} 
                                        customCss={{margin:0, marginTop:'10px', marginBottom:'10px'}}
                                    />
                                </Box>

                            </Box>
                        </Box>
                }
                <CustomDivider disabled={true}/>
            </React.Fragment>
        )}
        </Stack>
        {!disabledShowMore ? (
            <Button sx={{width : '100%', mt : 5, bgcolor : "multiplex.darkblue"}} onClick={handleShowMore} variant="contained">
            Voir plus
            </Button>
        ) : (
            <Button sx={{width : '100%', mt : 5}} variant="contained" disabled>
            Début du direct
            </Button>
        )}
        </Box>
    </Box>

}

// const CustomButton = styled(Button)(({ pressed }) => ({
//     margin : '10px',
//     backgroundColor: pressed ? 'green' : 'gray',
//     color: 'white',
//     boxShadow: pressed ? 'inset 2px 2px 5px rgba(0,0,0,0.3)' : '2px 2px 5px rgba(0,0,0,0.3)',
//     transform: pressed ? 'translateY(2px)' : 'translateY(0)',
//     '&:hover': {
//       backgroundColor: pressed ? 'darkgreen' : 'darkgray',
//       boxShadow: pressed ? 'inset 2px 2px 5px rgba(0,0,0,0.3)' : '2px 2px 5px rgba(0,0,0,0.3)',
//     },
//   }));

export default MatchPreview